import { accessNested, isObject, joinPaths } from 'utils/utils';
import Store from 'store/store';

let defaultRedirect = (geoFencedLocation, options) => {
	if (!geoFencedLocation) {
		return;
	}
	if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
		console.log('GEOFENCING GOING TO', geoFencedLocation);
		return;
	}

	// Try to prevent SOME infinite redirect loops (wouldn't catch a lot of things)
	let loopRisk = location.href === geoFencedLocation;
	if (!options?.allowSameHostRedirect) {
		let [, protocol, host] = /^((?:https?:)?\/\/)?([^/]+)/.exec(geoFencedLocation) || [];
		loopRisk = location.host === host;
	}
	if (!loopRisk) {
		location.href = geoFencedLocation;
	}
	return true;
};

let defaultGetRegionURL = (countryCode) => {
	return accessNested(Store.get(), ['dynamicData', 'regions', countryCode, 'url']);
};

// We do want to redirect accessed.com/page/a/ to redirect.com/page/a/
// However, our sites sometimes do not live at the root of the vanity
//   e.g. movies.powster.com/studio/movie/region/page/a/ -> redirect.com/page/a/
// So we need to figure out which part of the path to keep in the redirection
let getPathFromRoot = () => {
	// NOTE: this assumes that this function is called on landing, before any page change occurs
	// Otherwise, look into extracting root from getPagePath, like getRelativePageUrl
	const root = new URL(window.__RELATIVE_ROOT__, location.href);
	// Ignore query string and hash (handled separately)
	const rootOriginAndPath = root.origin + root.pathname;
	const currentOriginAndPath = location.origin + location.pathname;
	// If "root" is somehow a more deeply nested path than "current", default to the full pathname
	return currentOriginAndPath.startsWith(rootOriginAndPath) ? currentOriginAndPath.replace(rootOriginAndPath, '') : location.pathname;
};

export default async function geoFencing(getGeo, options) {
	if (!options) {
		options = {};
	}
	let redirect = typeof options.redirect === 'function' ? options.redirect : defaultRedirect;
	let redirectionActive = typeof location !== 'undefined' && !location.search.match(/[?&]redirect=(off|false|0|no)/);
	if (!redirectionActive || !window.__INITIAL_STATE__) {
		return;
	}
	let appData = window.__INITIAL_STATE__.appData || {};
	let accessedPath = getPathFromRoot();
	let queryString = location.search;
	let hash = location.hash;
	const opt = (include, val) => include ? val : '';
	let getDestination = (url, { stripPath, stripQS, stripHash } = {}) => (stripPath ? url : joinPaths(url, accessedPath)) + opt(!stripQS, queryString) + opt(!stripHash, hash);
	let geoFence = appData.geofencing || {};
	let redirectObj = appData.redirection || {};
	let appRegion = accessNested(appData, 'meta.region.slug');

	let countryCode = (await getGeo()).countryCode;

	// allow for regions to be ignored per request
	const regionAllow = geoFence.allowRegions || '';
	const ignoreFor = regionAllow.split(',').map(region => region.trim().toLowerCase()).filter(e => e);
	const ignoreGeoFence = ignoreFor.indexOf(countryCode) !== -1;
	// check if site is in correct country (and ignore if it is)
	if (appRegion !== countryCode && geoFence.geofencing && !ignoreGeoFence) {
		let geoFencedLocation = accessNested(geoFence, ['overrides', countryCode]);
		if (!geoFencedLocation) {
			let getRegionURL = typeof options.getRegionURL === 'function' ? options.getRegionURL : defaultGetRegionURL;
			let regionUrl = await getRegionURL(countryCode);
			geoFencedLocation = regionUrl || geoFence.defaultLink;
		}
		if (geoFencedLocation) {
			let url = geoFencedLocation;
			let stripPath = geoFence.stripRedirectionPath;
			if (isObject(geoFencedLocation)) {
				url = geoFencedLocation.url;
				if (geoFencedLocation.stripPath != undefined) {
					stripPath = geoFencedLocation.stripPath;
				}
			}
			return redirect(getDestination(url, { stripPath }), geoFence);
		}
	} else {
		// standard redirect behaviour
		try {
			let optionsList = Object.keys(redirectObj).map(k => redirectObj[k]).concat(redirectObj).filter(e => e?.url);
			let redirect;
			for (let option of optionsList) {
				let checklist = [];

				if (option.country) {
					let list = option.country.split(',').map(e => e.trim());
					checklist.push(list.includes(countryCode));
				}
				if (option.countryNot) {
					let list = option.countryNot.split(',').map(e => e.trim());
					checklist.push(!list.includes(countryCode));
				}

				// Nothing is actually async at this point but change back to this if needed
				// let result = (await Promise.all(checklist)).every(e => e);
				let result = checklist.every(e => e);
				if (result) {
					redirect = option;
					break;
				}
			}
			if (redirect) {
				return redirect(getDestination(redirect.url));
			}
		} catch (e) {
			console.log('Failed redirecting', e);
		}
	}
}
